<template>
  <div  class="explore-main">
    <div :class="['header',insBool?'display-none':'']">
        <img class="header-img" src="@a/explore/explore_header.png" />
        <div class="header-text">
            <h2>{{data_.headtitle}}</h2>
            <div class="header-hr"></div>
            <h4>职场是个交换场<br/>而能力则是我们交换的重要筹码<br/>当明确了目标岗位之后<br/>就需要对标自己的能力了</h4>
        </div>
    </div>
    <!-- 主题内容 -->
    <div class="explore-content">
        <div class="explore-card">
            <div class="p">
                <img class="p-img" src="@a/explore/issue.png" />
                <span>你知道你有哪些能力吗？</span>
            </div>
            <div class="p">
                <img class="p-img" src="@a/explore/issue.png" />
                <span>你知道哪些能力是你的甜蜜点，越用越有满足感吗？</span>
            </div>
            <div class="p">
                <img class="p-img" src="@a/explore/issue.png" />
                <span>你知道有哪些能力是你越用越有挫败感却不知道该怎么办的吗？</span>
            </div>
            <div class="hr"></div>
            <div class="p on">这个测试可以帮助你盘点你当前或未来工作中可能用到的能力。同时，它可以根据你是否喜欢使用及是否擅长进行归类。</div>
        </div>
        <!-- 开始测试按钮 -->
        <a @click="insBool=true" class="beginBtn">我准备好了，开始测试</a>
    </div>
    <!-- 引入说明组件 -->
    <div v-for="(item,index) in data_.list" v-if="index==list_index" :class="['ins-card',insBool?'on':'',insBool2?'display-none':'']">
        <img class="logo" src="@a/explore/logo.png" />
        <div class="instructions-main">
            <div class="card">
            <div class="bg"></div>
            <div class="card-box">
                <h3>{{item[0].question}}</h3>
                <h4 v-html="item[0].options"></h4>
            </div>
            </div>
            <!-- GO -->
            <a @click="insBool2=true" class="begin-btn">GO</a>
        </div>
    </div>
    <!-- 引入答题 -->
    <ins-questions @successful="successful" :class="['ins-questions',insBool2?'on':'']" v-if="insBool2"   :list_="list" ></ins-questions>
  </div>
</template>

<script>
import insQuestions from '@c/measurement/instructions-questions'
import { deepCopy } from '@/utils/tools'
export default {
    data(){
        return{
            insBool:false,
            insBool2:false,
            list_index:0,
            // 保存答题数据
            resultArr:[],
            successf:[],
            list:[]
        }
    },
    props:['data_'],
    methods:{
        // 替换文字颜色
        // fontColor(font){
        //     return font.replace('是否用得到',(v)=>{
        //         return v.fontcolor('#1c95d4');
        //     })
        // },
        // 答完一部分题目触发
        successful(arr){
            if(this.list_index==0){
                this.successf = arr;
            }
            this.resultArr = this.resultArr.concat(arr);

            if(this.list_index==2){
                // this.insBool2 = false;

                // 提交答题数据
                this.$emit('saveData',this.resultArr);

            }else{
                this.insBool2 = false;
                this.list_index+=1;
                // 处理第一部分选中的
                this.dealWith(this.list_index,this.successf);
            }

        },
        // 处理第一部分选中是的选项
        dealWith(idx,arr){
            let list2 = [];
            let list = this.data_.list[idx];
            for(let i = 0; i<list.length;i++){
                for(let k = 0; k<arr.length;k++){
                    if(i==0 || (list[i].eid==arr[k].eid && arr[k].score=='10')){
                        list2.push(list[i]);
                        break;
                    }
                }
            };
            this.$forceUpdate();
            this.list = list2;
        },
        pullData(){
            this.list = this.data_.list[this.list_index];
        }
    },
    
    components:{
        insQuestions
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.explore-main{
    .header{
        position: relative;
        .header-text{
            position:absolute;
            top:50%;
            left:30px;
            z-index:5;
            color:#FFFFFF;
            transform: translateY(-50%);
            h2{
                font-size:42px;
                line-height:1;
            }
            h4{
                font-size:28px;
                line-height:42px;
                letter-spacing: 1px;
            }
            .header-hr{
                width:77px;
                height:4px;
                margin:35px 0;
                background:rgba(255,255,255,1);
            }
        }
        .header-img{
            width:100%;
            height:418px;
            z-index:1;
        }
    }
    .explore-content{
        padding:30px;
        .explore-card{
            background-color:#fff;
            border-radius:12px;
            padding:50px 40px;
            .p{
                font-size:28px;
                color:#333;
                display:flex;
                margin-bottom:32px;
                .p-img{
                    width:30px;
                    height:30px;
                    margin-right:20px;
                    margin-top:7px;
                }
            }
            .p.on{
                margin-bottom:0px;
            }
            div.hr{
                height:2px;
                background:rgba(28,149,212,.2);
                margin:60px auto 50px;
            }
            
        }
        .beginBtn{
            font-size:34px;
            width:578px;
            line-height:80px;
            color:#fff;
            background:rgba(28,149,212,1);
            border-radius:40px;
            display: block;
            text-align: center;
            border: 1px solid;
            margin:60px auto 20px;
        }
    }
}
.ins-card,.ins-questions{
    background-color:#f0f0f0;
    position: fixed;
    top:0;
    left:-50%;
    width:100%;
    height:100%;
    max-width:750px;
    z-index:10;
    transform: translateX(-50%);
    transition:all .5s;
    overflow: auto;
    .logo{
        width: 137px;
        height: 56px;
        margin: 22px 30px;
    }
}
.ins-questions{
    z-index:30;
}
.ins-card.on,.ins-questions.on{
    left:50%;
}
.instructions-main{
  background-color:#f0f0f0;
  .card{
    position:relative;
    .bg{
      background: url(../../assets/explore/card_bg.png) center no-repeat;
      background-size: 100% 100%;
      border: none;
      height:305px;
    }
    .card-box{
      margin:-225px 30px 100px;
      background-color:#fff;
      border-radius:12px;
      padding:50px 42px 143px 42px;
      h3{
        font-size:32px;
        color:#333333;
        letter-spacing:1px;
        margin-bottom:60px;
        line-height:48px;
      }
      h4{
        font-size:36px;
        color:#333333;
        font-weight:bold;
        line-height:48px;
      }
    }
  }
  .begin-btn{
    width:578px;
    line-height:80px;
    background:rgba(28,149,212,1);
    border-radius:40px;
    display:block;
    margin:100px auto auto;
    color:#fff;
    font-size:34px;
    text-align:center;
  }
}
</style>